module.exports = __webpack_public_path__ + "media/images/lp/cta_btn-7209e8e0c6a5e86a5efd3dae441e88a2.webp";